<div class="compare-table">
  <h2 mat-dialog-title>{{ 'TRIPS.VEHICLE.COMPARISON' | translate }}</h2>
  <div>
    <div>
      <table class="mat-elevation-z8" mat-table [dataSource]="tableData" matSort [matSortActive]="null" [matSortDirection]="null">
        <!-- Vehicle name column (first column) -->
        <ng-container matColumnDef="ROWLABEL">
          <th mat-header-cell *matHeaderCellDef>{{ getHeader('ROWLABEL') }}</th>
          <td mat-cell *matCellDef="let row" [innerHTML]="row.ROWLABEL"></td>
        </ng-container>

        <!-- Data columns with alternating colors -->
        <ng-container *ngFor="let column of displayedColumns.slice(1); let i = index">
          <ng-container [matColumnDef]="column">
            <!-- Apply even/odd class based on column index -->
            <th mat-header-cell *matHeaderCellDef mat-sort-header 
                [ngClass]="i % 2 === 0 ? 'even-column' : 'odd-column'">
              {{ getHeader(column) }}
            </th>
            
            <!-- Apply same even/odd class to cells in this column -->
            <td mat-cell *matCellDef="let row" 
                [innerHTML]="row[column]"
                [ngClass]="i % 2 === 0 ? 'even-column' : 'odd-column'">
            </td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.hidden]="row.hiddenDetail"></tr>
      </table>
    </div>
  </div>
  
  <label *ngIf="errorMsg !== null" translate>
    {{ errorMsg }}
  </label>
</div>